module.exports = __webpack_public_path__ + "img/btn-logout-bm.27670d5e.png";